<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Dolly Lloyd is a Moldovan-born fashion designer who discovered her passion for fashion at the tender age of six, when her grandmother introduced her to sewing. Post attending school, she completed a degree in fashion at Northumbria University. Having honed her design skills working for various fashion brands, she finally created her own eponymous label under the name Teo Lloyd and opened a prestigious high street boutique in London. Her in-depth knowledge of the industry and insight into luxury brands has inspired her first novel in a forthcoming series.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?6a19e784